module.exports = require("npm:to-arraybuffer@1.0.1/index.js");